var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CodeRenderer from "../renderer/code-renderer";
import Registry from "../renderer/registry";
import SceneRenderer from "../renderer/scene-renderer";
import Toolbar from "../ui/toolbar";
export default function registration() {
    return __awaiter(this, void 0, void 0, function* () {
        const registry = new Registry();
        yield registry.register("Toolbar", new Toolbar())
            .then(toolbar => registry.addSceneChangeListener(toolbar))
            .then(toolbar => toolbar.listeners.add(registry));
        yield registry.register("SceneRenderer", new SceneRenderer())
            .then(listener => registry.addSceneChangeListener(listener))
            .then(renderer => renderer.listeners.add(registry));
        yield registry.register("CodeRenderer", new CodeRenderer())
            .then(listener => registry.addSceneChangeListener(listener));
        return registry;
    });
}
